(function(){
	document.querySelectorAll('.partial-carousel').forEach(element => {
		let autoplay = element.getAttribute('data-autoplay');
		jQuery(element).find('.carousel').slick({
			mobileFirst:true,
			autoplay: ('1' === autoplay),
			prevArrow: element.querySelector('[data-action="Previous"]'),
			nextArrow: element.querySelector('[data-action="Next"]'),
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
					}
				}
			]
		});
	});
}());